export default __webpack_public_path__ + "static/mobile-development-6115e8939589e19bdc649d2c2e22816f.png";